import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=bd7e219c&scoped=true&"
import script from "./TeamList.vue?vue&type=script&lang=js&"
export * from "./TeamList.vue?vue&type=script&lang=js&"
import style0 from "./TeamList.vue?vue&type=style&index=0&id=bd7e219c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7e219c",
  null
  
)

component.options.__file = "TeamList.vue"
export default component.exports